import React, { useMemo } from 'react';

import { MarketingCheckboxesBare } from './components/MarketingCheckboxesBare';

import { clsb } from '@core/js/utils/classNames.util';

import {
    MAIN_CONTACT_TYPES_FRONT,
    OPTIONAL_CONTACT_TYPES_FRONT } from '../../constants';

import { TMarketingCheckboxesProps } from './types';

import style from './MarketingCheckboxes.scss';

export const MarketingCheckboxes: React.FC<TMarketingCheckboxesProps> = ({
    classNames,
    products = [],
    isProductTitleHidden,
    contactTypes = [],
    isAdditionalContact,
    initialValues,
    onChange
}) => {
    const buildCls = clsb([style, classNames]);

    const contactTypesDefault = useMemo(() => {
        return isAdditionalContact
            ? [
                ...MAIN_CONTACT_TYPES_FRONT,
                ...OPTIONAL_CONTACT_TYPES_FRONT.filter((item) => !initialValues?.[item])
            ]
            : MAIN_CONTACT_TYPES_FRONT;
    }, [isAdditionalContact, initialValues]);

    return (
        <div className={buildCls(['checkboxWrap'])}>
            <MarketingCheckboxesBare
                products={products}
                isProductTitleHidden={isProductTitleHidden}
                onChange={onChange}
                classNames={classNames}
                contactTypes={contactTypes?.length ? contactTypes : contactTypesDefault}
            />
        </div>
    );
};
